class GravityForms {

	/**
	 * @param input
	 * @returns {string|*}
	 */
	getGfInputNumber( input ) {
		if ( !input ) {
			return '';
		}
		return input.getAttribute("id").replace('input_', '');
	}

	/**
	 * Get Gravity Form validation message element for this input number.
	 *
	 * @param inputNumber
	 * @returns {*}
	 */
	getGfValidationMessageEl(inputNumber) {
		return document.querySelector('#validation_message_' + inputNumber );
	}

	/**
	 * Get Gravity Forms parent field element from this input number.
	 *
	 * @param inputNumber
	 * @returns {*}
	 */
	getGfFieldEl(inputNumber) {
		return document.querySelector('#field_' + inputNumber );
	}

	/**
	 * Show a Gravity Forms validation message for this input number.
	 * Gravity forms does not provide a way to trigger client-side errors for a field.
	 *
	 * @param inputNumber
	 * @param message
	 */
	showGfValidationMessage(inputNumber, message) {
		let validationEl = this.getGfValidationMessageEl(inputNumber);
		if ( validationEl ) {
			validationEl.innerHTML = message;
			return;
		}

		let newValidationEl = document.createElement('div');
		newValidationEl.setAttribute('id', 'validation_message_' + inputNumber );
		newValidationEl.setAttribute('aria-invalid', "true");
		newValidationEl.classList.add('validation_message', 'gfield_description', 'gfield_validation_message');
		newValidationEl.innerHTML = message;

		let fieldEl = this.getGfFieldEl(inputNumber);
		if ( fieldEl ) {
			fieldEl.appendChild(newValidationEl);
			fieldEl.classList.add('gfield_error');
		}
	}

	/**
	 * Hide gravity forms validation message for this field number.
	 *
	 * @param inputNumber
	 */
	hideGfValidationMessage(inputNumber ) {
		let validationEl = this.getGfValidationMessageEl(inputNumber);
		if ( validationEl ) {
			validationEl.remove();
		}
		let fieldEl = this.getGfFieldEl(inputNumber);
		if ( fieldEl ) {
			fieldEl.classList.remove('gfield_error');
		}
	}
}

const GravityFormsInstance = new GravityForms();
export default GravityFormsInstance;
